<ul
  [attr.role]="credentials().length > 1 ? null : 'none'"
  class="credential-selection-list"
  [ngClass]="{
    'list-view': viewMode() === 'list',
    'grid-view': viewMode() === 'grid',
  }"
  infinite-scroll
  [infiniteScrollContainer]="scrollContainer()"
  [scrollWindow]="!scrollContainer()"
  [fromRoot]="!!scrollContainer()"
  (scrolled)="fetchMore.emit()">
  @for (credential of credentials(); track credential.id; let i = $index) {
    <accredible-credential-selection-tile
      role="listitem"
      [credential]="credential"
      [viewMode]="viewMode()"
      [disableSelection]="credential.disabled"
      (selectionChange)="onSelectionChange(credential.id, $event, credential)"
      [dataCy]="'credential-item-' + i" />
  }
</ul>
